/**
 * Created by Ning Jiang on 10/28/2019.
 */

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomWiggle.js");
import {Background, IBackgroundConfig} from "@nolimitcity/slot-game/bin/core/background/Background";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TweenLite} from "gsap";
import {DeadwoodGameConfig} from "../DeadwoodGameConfig";
import {DeadwoodGameModuleConfig} from "../DeadwoodGameModuleConfig";

export class DWBackground extends Background {

    public static DIM_STAGE:string = "DWBackgroundEvent_dimStage";
    public static DIM_REEL:string = "DWBackgroundEvent_dimReel";
    public static BURN_FRAME:string = "DWBackgroundEvent_burnFrame";
    public static FS_FIRE:string = "DWBackgroundEvent_fsFire";
    public static BURN_BONUS_FRAME:string = "DWBackgroundEvent_burnBonusFrame";
    public static SHOW_SHOOTOUT_LOGO:string = "DWBackgroundEvent_showShootOutLogo";

    private _background:PIXI.Sprite;
    private _reelBackground:PIXI.Sprite;
    private _bgLight:PIXI.Sprite;

    private _reelFrame:PIXI.Sprite;
    private _shootOutLogo:PIXI.Sprite;

    private _reelDim:PIXI.Graphics;
    private _stageDim:PIXI.Graphics;

    private _hotReelFrames:PIXI.Sprite[];
    private _hotReelFrameBurning:boolean = false;

    private _bgFireSprite:PIXI.Sprite;
    private _bgFireTween:TweenLite | null;
    private _bgFireBurning:boolean = false; // shall play burning animation.
    private _bgFireShow:boolean = false; // shall be resized.

    private _bonusReelFrame:PIXI.Sprite;
    private _bonusFrameBurning:boolean = false;

    private _foregroundLayer:ScalableLayer;
    private _fireForegroundLayer:ScalableLayer;

    private _nextMode:string;

    constructor(config:IBackgroundConfig) {
        super(config);

        this._foregroundLayer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.FOREGROUND.name);
        this._fireForegroundLayer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.FS_FOREGROUND.name);
    }

    protected addEventListeners():void {
        super.addEventListeners();

        EventHandler.addEventListener(this, DWBackground.DIM_STAGE, (event:GameEvent) => this.dimStage(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, DWBackground.DIM_REEL, (event:GameEvent) => this.dimReel(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, DWBackground.BURN_FRAME, (event:GameEvent) => this.burnFrame(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, DWBackground.FS_FIRE, (event:GameEvent) => this.fsFire(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, DWBackground.BURN_BONUS_FRAME, (event:GameEvent) => this.burnBonusFrame(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, DWBackground.SHOW_SHOOTOUT_LOGO, (event:GameEvent) => this.showShootOutLogo(event.params[0]));

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));

        EventHandler.addEventListener(this, SpinEvent.IDLE, (event:GameEvent) => this.onGameIdle());
    }

    private onGameDataParsed(data:ParsedGameData):void {
        this._nextMode = data.nextMode;
    }

    protected initAnimations():void {
        super.initAnimations();

        this._background = new PIXI.Sprite();
        this._background.anchor.set(0.5);
        // 1680x1680
        this._background.position.set(360, 360);
        this.addChild(this._background);
        (<PIXI.Texture>PIXI.utils.TextureCache["background/cloud"]).baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
        const backgroundSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("backgroundIdle"));
        backgroundSpine.autoUpdate = true;
        this._background.addChild(backgroundSpine);
        backgroundSpine.state.setAnimation(0, `animation`, true).timeScale = 0.05;
        DeadwoodGameModuleConfig.backgroundIdle.init(this._background);

        // this._bgLight = new PIXI.Sprite(GameResources.getTextures("bgLight")[0]);
        // this._bgLight.blendMode = PIXI.BLEND_MODES.ADD;
        // this._bgLight.anchor.set(0.5, 1);
        // this._bgLight.scale.set(6, 0.5);
        // this._bgLight.rotation = Math.PI;
        // this._bgLight.position.set(248, -400);
        // this.addChild(this._bgLight);

        const reelBackgroundLayer:ScalableLayer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        this._reelBackground = new PIXI.Sprite(GameResources.getTextures("reelBackground")[0]);
        this._reelBackground.anchor.set(0.5);
        this._reelBackground.position.set(GameConfig.instance.GAME_WIDTH * 0.5, DeadwoodGameConfig.instance.REEL_AREA_TOP + this._reelBackground.height * 0.5);
        reelBackgroundLayer.addChild(this._reelBackground);

        this._reelFrame = new PIXI.Sprite(GameResources.getTextures("reelFrame")[0]);
        this._reelFrame.anchor.set(0.5, 1);
        this._reelFrame.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT);
        this._foregroundLayer.addChild(this._reelFrame);

        this._hotReelFrames = [this.getHotReelFrame(), this.getHotReelFrame()];

        this._bonusReelFrame = new PIXI.Sprite(GameResources.getTextures("bonusReelFrame")[0]);
        this._bonusReelFrame.blendMode = PIXI.BLEND_MODES.ADD;
        this._bonusReelFrame.anchor.set(0.5);
        this._bonusReelFrame.alpha = 0;
        this._bonusReelFrame.position.set(this._reelBackground.x, this._reelBackground.y);
        this._foregroundLayer.addChild(this._bonusReelFrame);

        this._shootOutLogo = new PIXI.Sprite(GameResources.getTextures("bonusIntroPanel")[0]);
        this._shootOutLogo.anchor.set(0.5)
        this._shootOutLogo.scale.set(0.25);
        this._shootOutLogo.rotation = -0.27;
        this._shootOutLogo.position.set(-290 + this._reelFrame.x, -610 + this._reelFrame.y);
        this._shootOutLogo.alpha = 0;
        this._foregroundLayer.addChild(this._shootOutLogo);

        this._stageDim = new PIXI.Graphics();
        this._stageDim.beginFill(0x000000);
        this._stageDim.drawRect(-480, -480, 1680, 1680);
        this._stageDim.endFill();
        this._stageDim.alpha = 0;
        StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.BACKGROUND_DIM.name).addChild(this._stageDim);

        this._reelDim = new PIXI.Graphics();
        this._reelDim.beginFill(0x000000);
        this._reelDim.drawRect(GameConfig.instance.REEL_AREA_POS_X, DeadwoodGameConfig.instance.REEL_AREA_TOP, GameConfig.instance.REEL_AREA_WIDTH, DeadwoodGameConfig.instance.REEL_AREA_ACTUAL_HEIGHT);
        this._reelDim.endFill();
        this._reelDim.alpha = 0;
        const dimLayer:ScalableLayer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.REEL_DIM.name);
        dimLayer.addChild(this._reelDim);

        this._bgFireSprite = new PIXI.Sprite(GameResources.getTextures("fsFireBg")[0]);
        this._bgFireSprite.blendMode = PIXI.BLEND_MODES.ADD;
        this._bgFireSprite.anchor.set(0.5);
        this._bgFireSprite.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.5);
        this._bgFireSprite.alpha = 0;
        this._fireForegroundLayer.addChild(this._bgFireSprite);
    }

    private getHotReelFrame():PIXI.Sprite {
        const hotReelFrame:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("hotReelFrame")[0]);
        hotReelFrame.blendMode = PIXI.BLEND_MODES.ADD;
        hotReelFrame.anchor.set(0.5);
        hotReelFrame.position.set(GameConfig.instance.GAME_WIDTH * 0.5, this._reelFrame.y - this._reelFrame.height * 0.5);
        hotReelFrame.alpha = 0;
        this._foregroundLayer.addChild(hotReelFrame);
        return hotReelFrame;
    }

    private showShootOutLogo(show:boolean):void {
        TweenLite.to(this._shootOutLogo, 0.5, {alpha : show ? 1 : 0});
    }

    private dimStage(alpha:number, duration:number = 0):void {
        TweenLite.to(this._stageDim, duration, {alpha : alpha});
    }

    private dimReel(alpha:number, duration:number = 0):void {
        TweenLite.to(this._reelDim, duration, {alpha : alpha});
    }

    private burnFrame(on:boolean, duration:number):void {
        if(this._hotReelFrameBurning && this._hotReelFrameBurning === on) {
            return;
        }

        this._hotReelFrameBurning = on;
        this._hotReelFrames.forEach((hotFrame:PIXI.Sprite, index:number) => {
            TweenLite.to(hotFrame, duration, {
                alpha : on ? 1 : 0,
                onComplete : () => {
                    if(on && index === this._hotReelFrames.length - 1) {
                        this.frameBurnWiggle();
                    }
                }
            });
        });
    }

    // The version of TweenMax (repeat) that we are using can't use string as ease.
    private frameBurnWiggle():void {
        if(!this._hotReelFrameBurning) {
            this._hotReelFrames[0].alpha = 0;
            this._hotReelFrames[1].alpha = 0;
            return;
        }
        CustomWiggle.create("frameBurnWiggle", {wiggles : 10, type : "random"});
        TweenLite.fromTo(this._hotReelFrames[this._hotReelFrames.length - 1], 1,
            {alpha : 1},
            {
                alpha : 0.5, ease : "frameBurnWiggle", onComplete : () => this.frameBurnWiggle(), onUpdate : () => {
                    if(this._bgFireBurning) {
                        this._bgFireSprite.alpha = 0.5 + this._hotReelFrames[this._hotReelFrames.length - 1].alpha * 0.5;
                    }
                }
            }
        );
    }

    private fsFire(on:boolean, animate:boolean):void {
        if(on) {
            if(animate) {
                TweenLite.fromTo(this._bgFireSprite, 0.67,
                    {alpha : 0},
                    {alpha : 1, onCompete : () => this._bgFireBurning = true}
                );
                this._bgFireTween = TweenLite.fromTo(this._bgFireSprite.scale, 0.67,
                    {x : 1.8, y : 1.8},
                    {x : this.getBgFireScaleX(), y : this.getBgFireScaleY()});
            } else {
                this._bgFireSprite.alpha = 1;
                this._bgFireSprite.scale.set(this.getBgFireScaleX(), this.getBgFireScaleY());
                this._bgFireBurning = true;
            }
            this._bgFireShow = true;
        } else {
            if(this._bgFireTween) {
                if(this._bgFireTween.isActive()) {
                    this._bgFireTween.pause();
                    this._bgFireTween.kill();
                }
                this._bgFireTween = null;
            }
            this._bgFireBurning = false;
            TweenLite.to(this._bgFireSprite, 1, {alpha : 0, onComplete : () => this._bgFireShow = false});
        }
    }

    private burnBonusFrame(on:boolean, nearWin:boolean):void {
        this._bonusFrameBurning = on;
        TweenLite.to(this._bonusReelFrame, 0.3, {
            alpha : on ? 1 : 0,
            onComplete : () => {
                if(on) {
                    this.bonusFrameBurnWiggle(nearWin);
                }
            }
        });
    }

    private bonusFrameBurnWiggle(nearWin:boolean):void {
        if(!this._bonusFrameBurning) {
            this._bonusReelFrame.alpha = 0;
            return;
        }
        CustomWiggle.create("bonusFrameBurnWiggle", {
            wiggles : nearWin ? 5 : 20,
            type : nearWin ? "uniform" : "random"
        });
        TweenLite.fromTo(this._bonusReelFrame, 2,
            {alpha : 1},
            {
                alpha : nearWin ? 0.1 : 0.8,
                ease : "bonusFrameBurnWiggle",
                onComplete : () => this.bonusFrameBurnWiggle(nearWin)
            }
        );
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._bgFireTween && this._bgFireTween.isActive()) {
            this._bgFireTween.pause();
            this._bgFireTween.kill();
            this._bgFireTween = null;
        }

        if(this._bgFireShow) {
            this._bgFireSprite.scale.set(this.getBgFireScaleX(), this.getBgFireScaleY());
        }
    }

    private getBgFireScaleX():number {
        return MathHelper.floorToDecimals(NolimitApplication.screenBounds.width / this._bgFireSprite.parent.scale.x / 0.43 / this._bgFireSprite.texture.width, 2);
    }

    private getBgFireScaleY():number {
        return MathHelper.floorToDecimals(NolimitApplication.screenBounds.height / this._bgFireSprite.parent.scale.y / 0.43 / this._bgFireSprite.texture.height, 2);
    }

    private onGameIdle():void {
        if(this._nextMode === GameMode.NORMAL) {
            EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_BONUS_FRAME, false, false));
            EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_STAGE, 0, 0.35));
        }
    }
}